import React from "react";
import "./call.css";
import user from "../Images/user.png";
import mute from "../Images/mute.jpg";
import speaker from "../Images/speaker.jpg";
import hold from "../Images/hold.jpg";
import record from "../Images/record.jpg";
import callend from "../Images/endcall.jpg";

const Call = () => {
  console.log("INCALLPAGE");
  return (
    <div className="callpg">
      <div className="callhead">
        <h1>Call</h1>
      </div>
      <div className="userinfo">
        <div className="userimg">
          <img src={user} alt="" />
        </div>
        <div className="username">
          <h3>User</h3>
        </div>
        <div className="contain1">
          <div className="block">
            <div className="mute">
              <img src={mute} alt="" />
            </div>
            <div className="speaker">
              <img src={speaker} alt="" />
            </div>
          </div>
          <div className="block">
            <div className="record">
              <img src={record} alt="" />
            </div>
            <div className="hold">
              <img src={hold} alt="" />
            </div>
          </div>
        </div>
        <div className="contain2">
          <div className="hangup">
            <img src={callend} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Call;
